import React, { useState, useEffect, useCallback } from 'react';
import Header from '../../components/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessNotification from '../../components/Notifications/SuccessNotification';
import ErrorNotification from '../../components/Notifications/ErrorNotification';
import LoginNotification from "../../components/Notifications/LoginNotification";
import { faEdit, faTrashAlt, faSearch, faSignature, faUser, faUserPlus, faCircleArrowLeft, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import ValidateKPIModal from "../../components/ValidateKPIModal";
import StatusWhatsApp from "../../components/Notifications/StatusWhatsApp";
import Table from '../../components/Table';
import Section from '../../components/Section';
import DeleteModal from '../../components/DeleteModal';
import AddElectronicSignature from '../../components/AddElectronicSignature';
import apiClient from "../../axios";
import { Tooltip } from "react-tooltip";
import { useLocation, useNavigate } from 'react-router-dom';

const ElectronicSignature = ({ handleLogout }) => {
    const location = useLocation();
    const { ruc } = location.state || {};
    const { gemaId } = location.state || {};
    const { client } = location.state || {};
    const [data, setData] = useState([]);
    //const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [validateKpiVisible, setValidateKpiVisible] = useState(false);
    const [deleteItem, setDeleteItem] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
    const navigate = useNavigate();
    const [addElectronicS, setAddElectronicS,] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedStatsuItem, setSelectedStatusItem] = useState(null);


    const hasPermission = (permission) => {
        const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
        return permissions.includes(permission);
    };

    // Usa useCallback para memoizar fetchAllData
    const fetchAllData = useCallback(async (page = 1) => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/gema/company/users/${gemaId}?page=${page}`);
            if (Array.isArray(response.data.results)) {
                setData(response.data.results);
                setTotalItems(response.data.total);
            } else {
                setData([response.data.results]);
                setTotalItems(1);
            }
        } catch (error) {
            setIsErrorVisible(true);
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        } finally {
            setIsSuccessVisible(true);
            setLoading(false);
        }
    }, [gemaId])

    const handleRefresh = () => {
        fetchAllData(currentPage);
    };

    const handleSearch = useCallback(async (page = 1) => {
        try {
            const params = new URLSearchParams();
            if (searchTerm) params.append('search', searchTerm);

            const response = await apiClient.get(`/gema/company/users/${gemaId}?${params.toString()}&page=${page}`);

            if (Array.isArray(response.data.results)) {
                setData(response.data.results);
            } else {
                setData([response.data.results]);
            }
            setTotalItems(response.data.total);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        }
    }, [searchTerm, gemaId]);
    const handleFresh = async (code) => {
        //handleSearch(1)
        setCurrentPage(1);
        setSearchTerm(searchInput.trim());
    };

    useEffect(() => {
        if (searchTerm) {
            handleSearch(currentPage);
        } else {
            fetchAllData(currentPage);
        }

    }, [fetchAllData, handleSearch, searchTerm, currentPage]);


    const handleSignature = () => {
        setAddElectronicS(true);
    }
    const handleCloseSignature = () => {
        setAddElectronicS(false);
        handleRefresh()
    };


    const handleDeleteModal = (item) => {
        setSelectedDeleteItem(item);
        setDeleteItem(true);
    }
    const handleCloseDeleteModal = () => {
        setDeleteItem(false);
        setSelectedDeleteItem(null);
        handleRefresh()
    };
    const handleStatusClick = (item) => {
        setSelectedStatusItem(item);
        setModalVisible(true);
    };
    const handleCloseModal = () => {
        setModalVisible(false);
        setSelectedStatusItem(null);
        handleRefresh()
    };

    const handleClick = () => {
        navigate(-1);
    };

    const columns = [
        { title: "Id", key: "id" },
        { title: "Nombre", key: "name" },
        { title: "Email", key: "email" },
        { title: "Estado", key: "status" },
        { title: "Acciones", key: "acciones" },
    ];

    const renderRow = (item, index) => (
        <>
            <td>{item.id}</td>
            <td>{item.userName}</td>
            <td>{item.email}</td>
            <td>
                {item.flagActive ? (
                    <button
                        className="status_button"
                        onClick={() => handleStatusClick(item)}
                    >
                        <FontAwesomeIcon
                            icon={faCircleCheck}
                            style={{ color: "green", fontSize: "24px" }}
                        />
                    </button>
                ) : (
                    <button
                        className="status_button"
                        onClick={() => handleStatusClick(item)}
                    >
                        <FontAwesomeIcon
                            className="status_icon"
                            icon={faCircleXmark}
                            style={{ color: "red", fontSize: "24px" }}
                        />
                    </button>
                )}
            </td>
            <td>

                <Tooltip id="edit-tooltip" className="custom-tooltip" />
                {hasPermission('COMPANY_ADMIN_UPDATE') && (
                    <button
                        data-tooltip-id="edit-tooltip"
                        className="icon-button edit-button"
                        data-tooltip-content="Editar"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/UserElectronicSignature/${item.id}`, { state: { gemaId: gemaId , ruc: ruc , client: client} });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                )}
                <Tooltip id="delete-tooltip" className="custom-tooltip" />
                {hasPermission('COMPANY_ADMIN_DELETE') && (
                    <button
                        data-tooltip-id="delete-tooltip"
                        data-tooltip-content="Eliminar"
                        className="icon-button delete-button"
                        onClick={() => handleDeleteModal(item)}
                    //onClick={() => handleDelete(item.id)}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                )}
            </td>


        </>
    );

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title='Firma Electrónica' />
            <div className="home-content">
                <Section>
                    <div className="button-return-container">
                        <div className="contener-return">
                            <FontAwesomeIcon
                                className="basic-shortcut-icon"
                                style={{ cursor: "pointer" }}
                                icon={faCircleArrowLeft}
                                onClick={handleClick}
                            />
                        </div>
                        <div className="filter-form">
                            <div className="basic-info-form-group">
                                <input
                                    type="text"
                                    id="customer"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    placeholder="Usuario"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleFresh();
                                        }
                                    }}
                                />
                            </div>
                            <button className="basic-custom-button" onClick={handleFresh}>
                                <FontAwesomeIcon icon={faSearch} className="basic-shortcut-icon" />
                                Buscar
                            </button>
                        </div>
                    </div>

                    <div className="button-add">
                        {hasPermission('COMPANY_CREATE') && (
                            <button
                                className="basic-custom-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleSignature();
                                }}
                            >
                                <FontAwesomeIcon className="basic-shortcut-icon" icon={faSignature} />
                                Editar Firma Electrónica
                            </button>
                        )}
                    </div>
                    <div className="button-add">
                        {hasPermission('COMPANY_CREATE') && (
                            <button
                                className="basic-custom-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/UserElectronicSignature", { state: { gemaId: gemaId , ruc: ruc , client: client} });
                                }}
                            >
                                <FontAwesomeIcon className="basic-shortcut-icon" icon={faUserPlus} />
                                Crear Usuario
                            </button>
                        )}
                    </div>
                </Section>
                <Table
                    title={`Lista de Usuarios de la Compania del cliente (${client}) con RUC (${ruc})`}
                    rows={data}
                    columns={columns}
                    icon={faUser}
                    renderRow={renderRow}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setCurrentPage}
                    onRefresh={handleRefresh}
                    loading={loading}
                    flagPagination={true}
                />
                <SuccessNotification
                    message={"Se ha cargado correctamente"}
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
                <ErrorNotification
                    message="Ups! Ocurrió un Problema"
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />
                <LoginNotification
                    message="Vuelve a iniciar sesión"
                    isVisible={isInfoVisible}
                    onClose={() => setIsInfoVisible(false)}
                    onLogout={handleLogout}
                />

                {selectedDeleteItem && (
                    <DeleteModal
                        isVisible={deleteItem}
                        onClose={handleCloseDeleteModal}
                        identificator={selectedDeleteItem.id}
                        url={`/admin/companies`}
                    />
                )}
                {addElectronicS && (
                    <AddElectronicSignature
                        isVisible={addElectronicS}
                        onClose={handleCloseSignature}
                        ruc={ruc}
                        client={client}
                        edit={true}
                    />
                )}
                {selectedStatsuItem && (
                    <StatusWhatsApp
                        detail={selectedStatsuItem}
                        message={
                            selectedStatsuItem.flagActive
                                ? "Usuario Activo. ¿Desea Inactivarlo?"
                                : "Usuario Inactivo. ¿Desea Activarlo?"
                        }
                        isVisible={modalVisible}
                        onClose={handleCloseModal}
                        origen='userE'
                    />
                )}
                <ValidateKPIModal
                    message="No se puede crear conección porque el contrato no tiene el módulo necesario."
                    isVisible={validateKpiVisible}
                    onClose={() => setValidateKpiVisible(false)}
                />
            </div>
        </div>
    );
};

export default ElectronicSignature;
